export interface FaqItem {
    question: string;
    answer: string;
}

export const FAQ: FaqItem[] = [
    {
        question: 'How accurate is the AI food analysis?',
        answer: 'Fork is tuned on real, messy meals - not stock photos. Good lighting helps, and we keep refining our models as we gather more real-world examples.',
    },
    {
        question: 'What is the nutrition score?',
        answer: 'Each meal gets a 0-100 score so you can quickly judge balance. We consider protein, carbs, fats, fiber, and overall density, then share a short note on what to improve.',
    },
    {
        question: 'Do I need an internet connection?',
        answer: 'New meal analyses use the cloud so they stay accurate. Your history and insights stay available offline once they are saved.',
    },
    {
        question: 'Can I log meals with voice?',
        answer: 'Yes. You can describe a meal by voice if you cannot snap a photo, and we will create the log and nutrition estimate for you.',
    },
    {
        question: 'Is my data private and secure?',
        answer: 'We only use your photos and logs to provide analysis. You decide what stays saved, and you can delete your data whenever you want.',
    },
    {
        question: 'Can I track multiple meals per day?',
        answer: 'Absolutely. Log every meal and snack; Fork keeps the totals and insight summaries for you.',
    },
    {
        question: 'Which devices are supported?',
        answer: 'Fork is available on iPhone and Android, with Apple Watch logging for quick capture on the go.',
    },
    {
        question: 'Is Fork free to use?',
        answer: 'We are piloting with early users right now. Pricing and plans are shared in-app so you always know what you are opting into.',
    },
    {
        question: 'How do I edit a logged meal?',
        answer: 'Open any meal in your history to adjust items or portions. You can re-run analysis if the photo was unclear.',
    },
];
